import { css } from 'linaria';

export const icon = css`
  width: 40px;
  height: 40px;
  margin: 0 var(--space-200) 0 0;
`;

export const verticalIcon = css`
  margin-bottom: var(--space-150);
`;

export const markerStyles = css`
  margin: 0 0 var(--space-250) 0;
  max-width: 105px;
  height: auto !important;
  padding: 4px 6px !important;
  & > span {
    font-weight: 400 !important;
    font-family: var(--font-base) !important;
    line-height: 12px !important;
    letter-spacing: 0.2px !important;
    text-transform: none !important;
    white-space: normal;
  }
`;

export const singleCompensatedService = css`
  align-items: flex-end;
`;

export const singleServiceStyles = css`
  flex-direction: column;
  align-items: flex-start;
`;
